<template>
  <div ref="root">
    {{ text }}
  </div>
</template>

<script>
import Renderers, {getComponentClass} from "@/components/forms/renderers/Renderers";
import RtModule from "@/utils/RtModule";
import FormsLoader from "@/components/forms/FormsLoader";
import _ from "lodash";


export default {
  name: "ValueRenderer",

  mounted() {
    let path = this.changeRecord.pth;
    let lastPathElement = path[path.length - 1];
    if (!lastPathElement?.fid) {
      return;
    }
    let form = FormsLoader.detectFormConfig(lastPathElement.fid);
    let formField = form.fields.find((el) => el.fieldName === lastPathElement.nm);
    if (!formField) {
      return;
    }
    if (formField?.gridColTemplateComponent) {
      const clazz = getComponentClass(formField.gridColTemplateComponent, this.$router);
      let inst = {};
      inst[formField.fieldName] = this.value;
      let column = {fieldConfig: formField};

      const input = new clazz({
        propsData: {
          "rowIndex": 0,
          "prop": formField.fieldName,
          "model": inst,
          "column": column,
        }
      });

      this.$children.push(input);
      input.$parent = this;
      input.$root = this.$root;
      input.$mount();

      this.$refs.root.appendChild(input.$el);

      this.input = input;

    } else if (formField.gridColTemplate) {
      // TODO
    } else if (formField.gridToStringFunction) {
      if (!RtModule().hasFunction(formField.gridToStringFunction)) {
        Log.warn("No function found:" + formField.gridToStringFunction, true);
      } else {
        const fun = RtModule()[formField.gridToStringFunction];
        this.text = fun.call(form, this.value, formField, form);
      }
    } else {
      if (_.isArray(this.value)) {
        this.text = _.join(this.value, ", ");
      } else {
        this.text = this.value;
      }
    }
  },

  beforeDestroy() {
    if(this.input) {
      let input = this.input;
      input.beforeUnmount?.();
      input.$destroy?.();
      const index = this.$children.indexOf(input);
      if (index > -1) {
        this.$children.splice(index, 1);
      }
      setTimeout(() => {
        try {
          input?.afterUnmount?.();
        } finally {
          setTimeout(() => {
            input.onDestroy?.();
          });
        }
      });
      this.input = null;
    }
  },
  methods: {},

  props: {
    changeRecord: {default: null},
    value: {default: ""},
  },


  data: () => ({
    text: null,
  }),


}
</script>

<style scoped>

</style>